import { FormControl, Grid } from '@mui/material'
import React from 'react'
import { useTranslation } from 'react-i18next'
import { OPDropdown } from '../../../OPcomponents/OPDropdown'
import { OPRadioButton } from '../../../OPcomponents/OPRadioButton'
import CVCard from './CVCard'
import { useCVSettings } from './CVSettingsContext'

export const CVBasicSettings: React.FC = () => {
  const { t } = useTranslation()
  const { state, handleChange } = useCVSettings()
  const { cv_base, work_experience, cv_language } = state

  const experienceDisplayOptions = [
    {
      value: 'htp',
      label: t('CVTemplates.ShowExperienceInDays'),
    },
    {
      value: 'htkk',
      label: t('CVTemplates.ShowExperienceInMonths'),
    },
    {
      value: 'year',
      label: t('CVTemplates.ShowExperienceInYears'),
    },
  ]

  const cvBaseOptions = [
    {
      value: 'word',
      label: 'Word',
      disabled: false,
    },
    {
      value: 'pptx',
      label: 'PowerPoint',
      disabled: false,
    },
  ]

  return (
    <CVCard title={t('CVTemplates.BasicSettings')} description={t('CVTemplates.ChooseCVSettings')} showResetDefaultButton>
      <Grid container spacing={1} direction='column'>
        <Grid item xs={12}>
          <OPDropdown
            curState={cv_base}
            saveState={(e) =>
              handleChange({
                target: {
                  name: 'cv_base',
                  value: e.target.value,
                },
              } as React.ChangeEvent<HTMLInputElement>)
            }
            label={t('CVTemplates.CVTemplate')}
            dropdownItemList={cvBaseOptions}
          />
        </Grid>
        <Grid item xs={12}>
          <FormControl component='fieldset'>
            <OPRadioButton
              direction='column'
              name='work_experience'
              radioOptions={experienceDisplayOptions}
              label={t('CVTemplates.WorkExperienceFormat')}
              onChange={handleChange}
              defaultVal={work_experience}
            />
          </FormControl>
        </Grid>
        <Grid item xs={12}>
          <FormControl component='fieldset'>
            <OPRadioButton
              direction='column'
              name='cv_language'
              radioOptions={[
                { value: 'fi', label: t('CVTemplates.Finnish') },
                { value: 'en', label: t('CVTemplates.English') },
              ]}
              label={t('CVTemplates.Language')}
              onChange={handleChange}
              defaultVal={cv_language}
            />
          </FormControl>
        </Grid>
      </Grid>
    </CVCard>
  )
}
